import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { CatalogService } from './catalog.service';
import { CockehsuHeaderComponent } from './cockehsu-header.component';
import { CockehsuCatalogComponent } from './cockehsu-catalog.component';
import { CockehsuComponent } from './cockehsu.component';
import { CockehsuLoaderComponent } from './cockehsu-loader.component';
import { CockehsuDrawerComponent } from './cockehsu-drawer.component';

import { environment } from '../environments/environment';
import { CockehsuHelpComponent } from './cockehsu-help.component';

let defaultRoute: any = { path: '', component: CockehsuComponent };
if (environment.debugRoute !== undefined) {
  defaultRoute = environment.debugRoute;
}

const appRoutes: Routes = [
  {
    path: 'shop/:code/catalog/:uid',
    component: CockehsuComponent,
  },
  defaultRoute,
  {
    path: '**',
    component: CockehsuComponent,
  },
];


@NgModule({
  declarations: [
    AppComponent,
    CockehsuComponent,
    CockehsuHeaderComponent,
    CockehsuCatalogComponent,
    CockehsuLoaderComponent,
    CockehsuDrawerComponent,
    CockehsuHelpComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    HttpModule,
  ],
  providers: [
    CatalogService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts